import {AbstractControl} from '@angular/forms';

export function registrationNumberValidator(control: AbstractControl): { [key: string]: any } | null {
  if (!/^[a-zA-Z0-9]*$/.test(control.value)) {
    return {invalidRegistrationNumber: true};
  } else {
    return null;
  }
}
